define('adminGlossariesCreateEditView',[
  'module',
  'underscore',
  'marionette',
  'backbone',
  'jquery',
  'dialogFormView',
  'template!adminGlossariesCreateEditTpl',
  'savingBehavior',
  'dynamicTextView'
], function (
  module,
  _,
  Marionette,
  Backbone,
  $,
  DialogFormView,
  createEditLayoutTpl,
  SavingBehavior,
  DynamicTextView
) {
  'use strict';

  var CreateEditLayoutView = DialogFormView.extend({
    template: createEditLayoutTpl,

    ui: {
      input: '.js-info-input',
      individualPrinting: '#individualPrinting'
    },

    events: {
      'click .js-cancel-popup': 'hide',
      'focus @ui.input': 'onFocus',
      'change @ui.input': 'onInputChange',
      'click .js-confirm': 'onConfirm'
    },

    regions: {
      nameRegion: '.name-region'
    },

    className: 'profile-create-edit',

    behaviors: {
      Saving: {
        behaviorClass: SavingBehavior
      }
    },

    modelEvents: {
      sync: 'onSave',
      error: 'onSaveError'
    },

    fieldsToValidate: [
      {name: 'code', type: 'required'}
    ],

    initialize: function (options) {
      this.model = options.itModel;
    },

    serializeData: function () {
      var templateData = this.model.toJSON();
      templateData.newItem = this.options.newItem;
      return templateData;
    },

    onShow: function () {
      $.material.init();

      this.nameDtView = new DynamicTextView({
        model: this.model.get('refDynamicText'),
        noSaving: true,
        hideGlossary: true
      });
      this.nameDtView.dataUpdated = _.bind(function () {
        this.triggerMethod('enable:cancel:confirm');
      }, this);
      this.getRegion('nameRegion').show(this.nameDtView);
    },

    onConfirm: function () {
      if (this.validate(this.fieldsToValidate)) {
        this.model.save();
      }
    },

    onSave: function () {
      this.triggerMethod('saved');
      this.trigger('onSave');
      this.hide();
    },

    onSaveError: function (model, response) {
      if (response.status === 409) {
        this.onDuplicateCode();
        this.triggerMethod('hide:label');
      }
    }
  });

  module.exports = CreateEditLayoutView;
});
